import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'src/api/axiosInstance';

const initialState = {
  modules: [],
  screens: {},
  loading: false,
  initialized: false,
  error: null,
};

export const fetchPermissions = createAsyncThunk(
  'permission/fetchPermissions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/rest/roleConfig/currentPermissions');
      return response.data || {};
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch permissions');
    }
  },
  {
    condition: (_, { getState }) => {
      const { permission } = getState();
      if (!permission) return true;
      if (permission.loading) return false;
      if (Object.keys(permission.modules || {}).length > 0) return false;
      if (Object.keys(permission.screens || {}).length > 0) return false;
      return true;
    },
  }
);

const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    clearPermissions: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.initialized = true;
        state.error = null;
        state.modules = action.payload?.modules || [];
        state.screens = action.payload?.screens || {};
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.loading = false;
        state.initialized = true;
        state.error = action.payload || action.error?.message || 'Failed to fetch permissions';
      })
      .addCase('permission/permissionsSyncedFrom403', (state, action) => {
        state.loading = false;
        state.initialized = true;
        state.error = null;
        state.modules = action.payload?.modules || [];
        state.screens = action.payload?.screens || {};
      })
      .addCase('permission/permissionsSyncFailedFrom403', (state, action) => {
        state.loading = false;
        state.initialized = true;
        state.error = action.payload || 'Failed to sync permissions';
      })
      .addCase('auth/localLogout', () => initialState);
  },
});

export const { clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
